<template>
	<s-modal-bottom-sheet
		v-model="show"
		max-width="600"
	>
		<template #activator="{ on }">
			<v-btn
				class="py-2"
				outlined
				text
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				Добавить
			</v-btn>
		</template>
		<v-card>
			<v-card-title>Добавление файла</v-card-title>
			<v-card-text>
				<v-form
					ref="form"
					@submit.stop.prevent="submit"
				>
					<v-file-input
						ref="fileInput"
						name="file"
						label="Файл"
						outlined
						dense
						@change="focusDescriptionInput"
					/>
					<v-text-field
						ref="descriptionInput"
						name="description"
						label="Описание файла"
						outlined
						dense
					/>
					<v-btn
						type="submit"
						color="green"
						outlined
						:loading="loading"
					>
						Сохранить
					</v-btn>
				</v-form>
			</v-card-text>
		</v-card>
	</s-modal-bottom-sheet>
</template>

<script>
import SModalBottomSheet from '@/components/base/s-modal-bottom-sheet';
export default {
	name: 'RepairOrderMediaCreateModal',
	components: { SModalBottomSheet },
	props: {
		order: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		show: false,
		loading: false,
	}),
	watch: {
		show(val) {
			if (val === true) {
				this.$nextTick(() => {
					const block = this.$refs.fileInput.$el;
					block.querySelector('input[type=file]').click();
				});
			}
		},
	},
	methods: {
		async submit(event) {
			if (this.loading) return;
			this.loading = true;
			try {
				const formData = new FormData(event.target);
				const response = await this.$http.post(`/api/v2/service/orders/repair/${this.order}/media`, formData);
				this.show = false;
				this.$emit('created', response.data.data);
				this.$notify('Файл добавлен');
				this.$refs.form.reset();
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading = false;
			}
		},
		focusDescriptionInput() {
			this.$refs.descriptionInput.$el.querySelector('input').focus();
		},
	},
};
</script>

<style scoped>

</style>
